import KnowioLogo from "../../assets/knowio-logo.png";

import { useDispatch, useSelector } from "react-redux";
import { getGateways, getSensors, getSiteAnalytics, uploadHardware, getBranding } from "../../Api Methods/Api";
import { useEffect, useState, useRef, useMemo } from "react";
import statClasses from "../Dashboard/Dashboard.module.css";
import classes from "./gateways.module.css";
import { Await, useNavigate } from "react-router-dom";
import { Chart as ChartJS, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import { Chart } from "react-chartjs-2";
import PadlocksList from "../Padlocks/padlocksList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import StatCard from "../../components/UI/Stats/StatCard";
import mixpanel from "mixpanel-browser";
import refreshBtn from '../../assets/portalAssets/refreshV2.png';
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown"
import Papa from "papaparse";
import Lottie from "lottie-react";
import loadingAnim from "../../assets/animations/newLoading.json";
import AllSitesSearchBar from "../AllSites/allSitesSearchBar";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from "date-fns";
import { logoMap } from "../../helpers/GroupLogoMap";


ChartJS.register(CategoryScale, LinearScale, Tooltip, Legend, MatrixController, MatrixElement);

const toggleOptions = ["Battery", "Signal"];

const getBatteryColor = (value) => {
    if (value === null || value === undefined) return 'rgba(200, 200, 200, 0.3)';

    const v = Math.max(0, Math.min(100, value));

    const red = { r: 235, g: 14, b: 14 };
    const yellow = { r: 235, g: 218, b: 38 };
    const green = { r: 42, g: 204, b: 20 };

    let r, g, b;
    if (v <= 50) {
        const t = v / 50;
        r = Math.round(red.r + (yellow.r - red.r) * t);
        g = Math.round(red.g + (yellow.g - red.g) * t);
        b = Math.round(red.b + (yellow.b - red.b) * t);
    } else {
        const t = (v - 50) / 50;
        r = Math.round(yellow.r + (green.r - yellow.r) * t);
        g = Math.round(yellow.g + (green.g - yellow.g) * t);
        b = Math.round(yellow.b + (green.b - yellow.b) * t);
    }

    return `rgba(${r}, ${g}, ${b}, 0.8)`;
};

const getSignalColor = (value) => {
    if (value === null || value === undefined) return 'rgba(200, 200, 200, 0.3)';

    const v = Math.max(0, Math.min(100, value));

    const lightBlue = { r: 189, g: 218, b: 250 };
    const darkBlue = { r: 30, g: 64, b: 175 };

    const t = v / 100;
    const r = Math.round(lightBlue.r + (darkBlue.r - lightBlue.r) * t);
    const g = Math.round(lightBlue.g + (darkBlue.g - lightBlue.g) * t);
    const b = Math.round(lightBlue.b + (darkBlue.b - lightBlue.b) * t);

    return `rgba(${r}, ${g}, ${b}, 0.8)`;
};

const HeatmapLegend = ({ type }) => (
    <div style={{ display: "flex", gap: "18px", alignItems: "center", fontSize: "12px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px"}}>
            <p>0%</p>
            <div className={type === "Signal" ? classes.gradientSignal : classes.gradient} />
            <p>100%</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <div style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: "rgba(200, 200, 200, 0.5)" }} />
            <span>No data</span>
        </div>
    </div>
);

const HeatmapCard = ({ data, type, labels, onCellClick, chartRef }) => {
    const hasData = data?.length > 0;
    const colorFn = type === "Signal" ? getSignalColor : getBatteryColor;

    const shortenLabel = (label) => label.length > 25 ? label.substring(0, 25) + '...' : label;

    const headerOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false }
        },
        scales: {
            x: {
                type: 'category',
                position: 'top',
                labels: labels.dates,
                grid: { display: false },
                border: { display: false },
                ticks: { font: { size: 11 } }
            },
            y: {
                type: 'category',
                labels: labels.gateways,
                grid: { display: false },
                border: { display: false },
                ticks: {
                    font: { size: 11 },
                    callback: function(value) {
                        return shortenLabel(this.getLabelForValue(value));
                    },
                    color: 'transparent'
                },
                afterFit: (axis) => { axis.width = 150; }
            }
        }
    };

    const mainOptions = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: (event, elements) => {
            if (elements.length > 0 && onCellClick) {
                const index = elements[0].index;
                const item = data[index];
                if (item) onCellClick(item.y);
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    title: () => '',
                    label: (context) => {
                        const item = context.dataset.data[context.dataIndex];
                        if (item.v === null) return `${item.y}: No data`;
                        return `${item.y}: ${item.v}%`;
                    }
                }
            }
        },
        scales: {
            x: {
                type: 'category',
                position: 'top',
                labels: labels.dates,
                grid: { display: false },
                border: { display: false },
                ticks: { display: false },
                afterFit: (axis) => { axis.height = 0; }
            },
            y: {
                type: 'category',
                labels: labels.gateways,
                grid: { display: false },
                border: { display: false },
                ticks: {
                    font: { size: 11 },
                    autoSkip: false,
                    callback: function(value) {
                        return shortenLabel(this.getLabelForValue(value));
                    }
                },
                afterFit: (axis) => { axis.width = 150; }
            }
        }
    };

    const headerData = { datasets: [] };

    const chartData = {
        datasets: [{
            data: data,
            backgroundColor(context) {
                const item = context.dataset.data[context.dataIndex];
                return colorFn(item?.v);
            },
            borderWidth: 0,
            width: ({ chart }) => (chart.chartArea || {}).width / labels.dates.length - 2,
            height: ({ chart }) => (chart.chartArea || {}).height / labels.gateways.length - 2
        }]
    };

    return (
        <div className={statClasses.chartCard} style={{ width: "100%", boxSizing: "border-box" }}>
            {!hasData ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "200px" }}>
                    <p style={{ textAlign: "center", color: "#888888" }}>
                        No analytics data available for the last 14 days.
                    </p>
                </div>
            ) : (
                <>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                        <p className={statClasses.chartTitle} style={{ margin: 0 }}>{type === "Battery" ? "Battery Levels" : "Signal Strength"}</p>
                        <HeatmapLegend type={type} />
                    </div>
                    <div style={{ height: 100, marginBottom: -65 }}>
                        <Chart type="matrix" data={headerData} options={headerOptions} />
                    </div>
                    <div style={{ maxHeight: 900, overflowY: "auto" }}>
                        <div style={{ height: labels.gateways.length <= 3 ? labels.gateways.length * 50 : Math.max(150, labels.gateways.length * 20) }}>
                            <Chart ref={chartRef} type="matrix" data={chartData} options={mainOptions} style={{ cursor: "pointer" }} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const RTSectionHeaderGateway = ({ title, onRefresh, bsToggle, setBSToggle, powerSource, setPowerSource, gwSearchTerm, setGwSearchterm, generatePDF, data }) => (
    <div className={statClasses.sectionHeaderTime} style={{ marginTop: "12px", marginBottom: "12px"}}>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <p className={statClasses.sectionTitle}>{title}</p>
                    {/* 
                    <Dropdown 
                        value={powerSource}
                        options={["All", "Battery", "Solar"]}
                        placeholder="Filter by power source"
                        onChange={(e) => setPowerSource(e.value)}
                        className={statClasses.dropdown}
                        style={{width: "200px", border: "1px solid #00000084", marginLeft: "6px", marginRight: "4px"}}
                    />
                    */}
                    <img className={classes.refreshButton} onClick={onRefresh} src={refreshBtn} />  
                
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <AllSitesSearchBar 
                    type="text"
                    placeholder="Search by gateway or site..."
                    inputSearchBarStyle={classes.searchBar}
                    inputFilterIconStyle={classes.filterButton}
                    value={gwSearchTerm}
                    onChange={(e) => setGwSearchterm(e.target.value)}
                    showFilterButton={true}
                    showGatewayFilters={true} // key
                    setBSToggle={setBSToggle}
                    bsToggle={bsToggle}
                    setPowerSource={setPowerSource}
                    powerSource={powerSource}
                />
                {/* 
                <SelectButton
                    className={classes.filterToggle}
                    value={bsToggle}
                    onChange={(e) => setBSToggle(e.value)}
                    options={toggleOptions} />
                */}
                {data?.labels?.gateways?.length > 0 && (
                    <Button
                        label="Export PDF"
                        icon="pi pi-file-pdf"
                        style={{
                            height: "28px",
                            fontSize: "14px",
                            padding: "6px 10px",
                            lineHeight: "1",
                            width: '125px'
                        }}
                        onClick={generatePDF}
                    />
                )}
            </div>
        </div>
    </div>
);

const SkeletonBarChart = () => (
    <div className={statClasses.chartCard}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
            <div className={statClasses.skeletonBar} style={{ height: "14px", width: "120px" }} />
            <div className={statClasses.skeletonBar} style={{ height: "14px", width: "180px" }} />
        </div>
        <div className={statClasses.skeletonBar} style={{ height: "500px", width: "100%" }} />
    </div>
);

const Gateways = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const companyName = useSelector(state => state.auth.companyName);
    const apiDataRef = useRef({ token, client, companyName });
    apiDataRef.current = { token, client, companyName };

    const role = useSelector(state => state.auth.role);
    const apiData = {
        token,
        client
    }

    const savedState = JSON.parse(sessionStorage.getItem('gatewayState') || 'null');

    const [gateways, setGateways] = useState([])
    const [billableGateways, setBillableGateways] = useState(0)
    const [nonBillableGateways, setNonBillableGateways] = useState(0)
    const [criticalGateways, setCriticalGateways] = useState([])
    const [warningGateways, setWarningGateways] = useState([])
    const [healthyGateways, setHealthyGateways] = useState([])
    const [offlineGateways, setOfflineGateways] = useState([])
    const [staleGateways, setStaleGateways] = useState([])
    const [update, setUpdate] = useState(0)
    const filtering = ""
    const [isLoading, setIsLoading] = useState(true)
    const [counts, setCounts] = useState([])
    const [gatewayStats, setGatewayStats] = useState(null)
    const [gatewayStatsOriginal, setGatewayStatsOriginal] = useState(null)
    const [activeTab, setActiveTab] = useState(savedState ? savedState.activeTab : 0);
    const [isLoadingScheduleStats, setIsLoadingScheduleStats] = useState(true)
    const [bsToggle, setBSToggle] = useState(savedState ? savedState.bsToggle : null)
    const [chartFilter, setChartFilter] = useState(null)
    const [powerSource, setPowerSource] = useState(savedState ? savedState.powerSource : null);
    const [gwSearchTerm, setGwSearchterm] = useState(savedState ? savedState.gwSearchTerm : null);

    const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
    const [hardwareFile, setHardwareFile] = useState(null);
    const [imeiList, setImeiList] = useState([]);
    const [imeiParseError, setImeiParseError] = useState(null);
    const [loadingDialogVisible, setLoadingDialogVisible] = useState(false);
    const [brandingName, setBrandingName] = useState(" ");

    const batteryChartRef = useRef(null);
    const signalChartRef = useRef(null);

    const generatePDF = () => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const margin = 14;

        const companyNameStr = apiDataRef.current.companyName || localStorage.getItem('companyName') || "";
        const dateRangeStr = `${format(last14, "MMM d, yyyy")} - ${format(now, "MMM d, yyyy")}`;
        const filename = `gateway-health-${companyNameStr.toLowerCase()}-${format(new Date(), "yyyy-MM-dd")}.pdf`;

        const showBattery = bsToggle === null || bsToggle === "Battery";
        const showSignal = bsToggle === null || bsToggle === "Signal";

        const parseRgba = (rgbaStr) => {
            const match = rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            if (match) return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3])];
            return [200, 200, 200];
        };

        // table build
        const buildTableData = (data, type) => {
            const colorFn = type === "Battery" ? getBatteryColor : getSignalColor;
            const dates = heatmapData.labels.dates;
            const gateways = heatmapData.labels.gateways;

            const headers = [{ content: 'Gateway', styles: { halign: 'left', fillColor: [28, 37, 54], textColor: [255, 255, 255] } }];
            dates.forEach(date => {
                headers.push({ content: date, styles: { halign: 'center', fillColor: [28, 37, 54], textColor: [255, 255, 255] } });
            });

            const rows = gateways.map(gateway => {
                const row = [{ content: gateway.length > 20 ? gateway.substring(0, 20) + '...' : gateway, styles: { halign: 'left', fillColor: [245, 245, 245] } }];

                dates.forEach(date => {
                    const entry = data.find(d => d.y === gateway && d.x === date);
                    const value = entry?.v;
                    const colorStr = colorFn(value);
                    const rgb = parseRgba(colorStr);
                    const displayVal = value === null ? '-' : `${value}%`;
                    const textColor = value !== null && value < 30 && type === "Battery" ? [255, 255, 255] : [30, 30, 30];

                    row.push({
                        content: displayVal,
                        styles: { halign: 'center', fillColor: rgb, textColor: textColor }
                    });
                });

                return row;
            });

            return { headers: [headers], rows };
        };

        const addHeader = (title) => {
            doc.setFillColor(28, 37, 54);
            doc.rect(0, 0, pageW, 24, 'F');

            if (logo) {
                doc.addImage(logo, 'PNG', pageW - margin - 14, 3, 14, 14);
            }

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.setTextColor(255, 255, 255);
            doc.text(`${companyNameStr} - Gateway Health`, margin, 10);

            doc.setFontSize(10);
            doc.text(title, margin, 17);

            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(180, 195, 220);
            doc.text(`${dateRangeStr}  •  Generated: ${format(new Date(), "MMM d, yyyy")}`, pageW - margin - 14 - 5, 21, { align: 'right' });
        };

        const addTable = (title, data, type, startY) => {
            const tableData = buildTableData(data, type);

            autoTable(doc, {
                head: tableData.headers,
                body: tableData.rows,
                startY: startY,
                margin: { top: 28, left: margin, right: margin, bottom: 18 },
                showHead: 'everyPage',
                styles: {
                    fontSize: 7,
                    cellPadding: 2,
                    lineWidth: 0.1,
                    lineColor: [200, 200, 200]
                },
                headStyles: {
                    fontSize: 7,
                    fontStyle: 'bold'
                },
                columnStyles: {
                    0: { cellWidth: 45 } 
                },
                didDrawPage: (data) => {
                    const pageTitle = data.pageNumber > 1 ? title + ` (continued)` : title;
                    addHeader(pageTitle);
                }
            });

            return doc.lastAutoTable.finalY;
        };

        let currentY = 28;

        if (showBattery && heatmapData.battery.length > 0) {
            addTable('Battery Levels', heatmapData.battery, 'Battery', currentY);
        }

        if (showSignal && heatmapData.signal.length > 0) {
            if (showBattery) {
                doc.addPage();
            }
            addTable('Signal Strength', heatmapData.signal, 'Signal', 28);
        }

        doc.setFillColor(28, 37, 54);
        doc.rect(0, pageH - 10, pageW, 10, 'F');
        doc.setTextColor(180, 195, 220);
        doc.setFontSize(7);
        doc.text('Portal Analytics Report', pageW / 2, pageH - 4, { align: 'center' });

        doc.save(filename);
    }

    const handleHardwareFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setHardwareFile(file);
        setImeiList([]);
        setImeiParseError(null);

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                if (!results.meta.fields?.includes("Manufacturer Serial")) {
                    setImeiParseError("No 'Manufacturer Serial' column found in the file.");
                    return;
                }
                const imeis = results.data
                    .map(row => row["Manufacturer Serial"])
                    .filter(v => typeof v === "string" && v.trim() !== "")
                    .map(v => v.trim());
                setImeiList(imeis);
            }
        });
    };

    const handleCellClick = (gatewayLabel) => {
        sessionStorage.setItem('gatewayState', JSON.stringify({
            activeTab,
            bsToggle,
            powerSource,
            gwSearchTerm
        }))
        const imei = heatmapData.labels.imeiMap?.[gatewayLabel];
        if (imei) navigate(`/Dashboard/Gateways/Gateway/${imei}`);
    };

    const logo = logoMap[brandingName] || KnowioLogo

    const lastRefreshTime = useRef(0);
    const cooldown = 8000;

    const now = new Date();
    const last14 = new Date();
    last14.setDate(now.getDate() - 14);

    const formatEventDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        return `${day}/${month}`;
    };

    const formatImei = (imei) => {
        if (!imei) return "Unknown";
        return "x" + imei.slice(-4);
    };

    // label or key for lookup
    const gatewayLookup = useMemo(() => {
        if (!gatewayStats || gatewayStats.length === 0) return {};

        const lookup = {};
        gatewayStats.forEach(item => {
            const label = item.tag || item.key;
            if (!label) return;
            if (!lookup[label]) {
                lookup[label] = { imei: item.imei, battery: item.battery };
            } else if (item.battery != null) {
                lookup[label].battery = item.battery;
            }
        });
        return lookup;
    }, [gatewayStats]);

    const uniqueTags = useMemo(() => {
        return Object.keys(gatewayLookup);
    }, [gatewayLookup]);

    // battery stats based on tags
    const batteryStats = useMemo(() => {
        if (uniqueTags.length === 0) {
            return { critical: 0, warning: 0, healthy: 0, total: 0 };
        }

        const readings = Object.values(gatewayLookup).filter(g => g.battery != null);
        const critical = readings.filter(r => r.battery < 10).length;
        const warning = readings.filter(r => r.battery >= 10 && r.battery < 30).length;
        const healthy = readings.filter(r => r.battery >= 30).length;

        return { critical, warning, healthy, total: readings.length };
    }, [gatewayLookup, uniqueTags]);

    const heatmapData = useMemo(() => {
        if (!gatewayStats || gatewayStats.length === 0 || uniqueTags.length === 0) {
            return { battery: [], signal: [], labels: { dates: [], gateways: [], imeiMap: {} } };
        }

        const validStats = gatewayStats.filter(item => item.tag || item.key);
        const uniqueDates = [...new Set(validStats.map(item => item.event_date))].sort();
        const formattedDates = uniqueDates.map(formatEventDate);

        const getStatusPriority = (battery) => {
            if (battery < 10) return 0;
            if (battery < 30) return 1;
            return 2;
        };

        const sortedLabels = [...uniqueTags].sort((a, b) => {
            const batteryA = gatewayLookup[a]?.battery ?? 100;
            const batteryB = gatewayLookup[b]?.battery ?? 100;
            const priorityA = getStatusPriority(batteryA);
            const priorityB = getStatusPriority(batteryB);
            if (priorityA !== priorityB) return priorityB - priorityA;
            return batteryB - batteryA;
        });

        const imeiMap = {};
        sortedLabels.forEach(label => {
            imeiMap[label] = gatewayLookup[label]?.imei;
        });

        const batteryData = [];
        const signalData = [];

        sortedLabels.forEach((label) => {
            uniqueDates.forEach((date) => {
                const dateLabel = formatEventDate(date);
                const entry = validStats.find(item => item.event_date === date && (item.tag || item.key) === label);

                batteryData.push({
                    x: dateLabel,
                    y: label,
                    v: entry?.battery ?? null
                });

                signalData.push({
                    x: dateLabel,
                    y: label,
                    v: entry?.signal === 0 ? 1 : (entry?.signal ?? null)
                });
            });
        });

        return {
            battery: batteryData,
            signal: signalData,
            labels: { dates: formattedDates, gateways: sortedLabels, imeiMap }
        };
    }, [gatewayStats, uniqueTags, gatewayLookup]);

    const handleRefreshStats = async () => {
        const currentTime = Date.now();
        if (currentTime - lastRefreshTime.current < cooldown) {
            setIsLoadingScheduleStats(true);
            setTimeout(() => {
                setIsLoadingScheduleStats(false);
            }, 2000);
            return;
        }
        lastRefreshTime.current = currentTime;

        setIsLoadingScheduleStats(true);
        setGatewayStats([]);
        setGatewayStatsOriginal([]);
        const response = await getSiteAnalytics(apiDataRef.current, {
            siteUUID: "",
            groupName: apiDataRef.current.companyName || localStorage.getItem("companyName"),
            start_date: last14,
            end_date: now,
            analyticsType: "gateways"
        }, dispatch);
        setGatewayStats(response.data[0]);
        setGatewayStatsOriginal(response.data[0]);
        setIsLoadingScheduleStats(false);
    };

    const GetBrandingName = async (groupName) => {
        let body = {
            groupName: groupName ?? companyName
        }

        const response = await getBranding(apiData, body, dispatch)
        if (response.success){
            setBrandingName(response.data["emailBranding"])
        }
    }
    
      useEffect(() => {
        GetBrandingName();
      }, [companyName])

    useEffect(() => {
        const tabNumber = activeTab;

        const tabTracking = {
            0: "Gateways tab visited",
            1: "Group Gateway Analytics visited"
        };

        if (tabTracking[tabNumber]) {
            mixpanel.track(tabTracking[tabNumber], {
            user: localStorage.getItem('email')
        });
        }
    }, [activeTab])

    useEffect(() => {
        if (savedState) {
            sessionStorage.removeItem('gatewayState');
        }
    }, []);

    useEffect(() => {
        if (!gatewayStatsOriginal) return;

        let filtered = gatewayStatsOriginal;

        if (powerSource === "Battery powered") {
            filtered = filtered.filter((gw) => gw.poweredBy === "battery");
        } else if (powerSource === "Solar powered") {
            filtered = filtered.filter((gw) => gw.poweredBy === "solar");
        }

        if (gwSearchTerm) {
            filtered = filtered.filter((gw) =>
                Object.values(gw).some((value) =>
                    value?.toString().toLowerCase().includes(gwSearchTerm.toLowerCase())
                )
            );
        }

        setGatewayStats(filtered);
    }, [powerSource, gwSearchTerm, gatewayStatsOriginal])

    //Pull data on mount
    useEffect(() => {
        const HandleGetGateways = async () => {
            const response = await getGateways(apiData, dispatch);
            console.log(response.data[0]);
            // console.log(JSON.parse(response.data[0][0].result));
            // const parsed = JSON.parse(response.data[0][0].result);
            // setGateways(parsed.data);
            // setCounts(parsed.counts)
            // console.log(counts);
            setBillableGateways(response.data[0].filter(lock => lock.billable == 1 && lock.billedToName === companyName))
            setNonBillableGateways(response.data[0].filter(lock => lock.billable == 0))
            setCriticalGateways(response.data[0].filter(lock => lock.battery <= 10))
            setWarningGateways(response.data[0].filter(lock => lock.battery > 10 && lock.battery < 30))
            setHealthyGateways(response.data[0].filter(lock => lock.battery >= 30))
            setOfflineGateways(response.data[0].filter(lock => lock.status == "stale"))
            setStaleGateways(response.data[0].filter(lock => lock.status == "potentiallyStale"))
            setGateways(response.data[0])
            setIsLoading(false)
        }

        const HandleGetGatewayStats = async () => {
            setIsLoadingScheduleStats(true);
            setGatewayStats([]);
            setGatewayStatsOriginal([]);
            const response = await getSiteAnalytics(apiDataRef.current, {
                siteUUID: "",
                groupName: apiDataRef.current.companyName || localStorage.getItem("companyName"),
                start_date: last14,
                end_date: now,
                analyticsType: "gateways"
            }, dispatch);
            setGatewayStats(response.data[0]);
            setGatewayStatsOriginal(response.data[0]);
            setIsLoadingScheduleStats(false);
        }

        HandleGetGateways();
        HandleGetGatewayStats();

    }, [update])

    const UploadHardware = async () => {
        const body = {
            "hardwareType": "GATEWAY",
            "hardwareID": imeiList
        }

        console.log(body);
        const response = await uploadHardware(apiData, body, dispatch)
        console.log(response);
        if (response.success){
            setLoadingDialogVisible(false)
        }
    }

    return (
        <Await resolve={gateways}>
            <div style={{ width: "100%" }}>
                {activeTab === 0 && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 290px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
                    <StatCard title={"Gateways"} value={gateways.length} isLoading={isLoading} />
                    <StatCard title={"Offline gateways"} value={offlineGateways.length} isLoading={isLoading} />
                    <StatCard title={"Check-in missed"} value={staleGateways.length} isLoading={isLoading} />
                    <StatCard title={"Critical gateways (<10% battery)"} value={criticalGateways.length} isLoading={isLoading} />
                    <StatCard title={"Warning gateways (<30% battery)"} value={warningGateways.length} isLoading={isLoading} />
                    <StatCard title={"Healthy gateways (≥30% battery)"} value={healthyGateways.length} isLoading={isLoading} />
                    <StatCard title={"Billable gateways"} value={billableGateways.length} isLoading={isLoading} />
                    <StatCard title={"Non-billable gateways"} value={nonBillableGateways.length} isLoading={isLoading} />
                </div>
                )}

                {activeTab === 1 && (
                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}>
                        <div style={{ flex: 1, minWidth: "150px" }}>
                            <StatCard title={"Total"} value={batteryStats.total} isLoading={isLoadingScheduleStats} />
                        </div>
                        <div style={{ flex: 1, minWidth: "150px" }}>
                            <StatCard title={"Healthy"} value={batteryStats.healthy} hasLabel={true} label={"≥ 30% Battery"} isLoading={isLoadingScheduleStats} />
                        </div>
                        <div style={{ flex: 1, minWidth: "150px" }}>
                            <StatCard title={"Warning"} value={batteryStats.warning} hasLabel={true} label={"< 30% Battery"} isLoading={isLoadingScheduleStats} />
                        </div>
                        <div style={{ flex: 1, minWidth: "150px" }}>
                            <StatCard title={"Critical"} value={batteryStats.critical} hasLabel={true} label={"< 10% Battery"} isLoading={isLoadingScheduleStats} />
                        </div>
                    </div>
                    )}
                {companyName === "EyeSpyFX" && (
                    <>
                        <div style={{ marginBottom: "12px" }}>
                            <Button
                                label="Upload hardware"
                                icon="pi pi-upload"
                                severity="secondary"
                                onClick={() => { setHardwareFile(null); setUploadDialogVisible(true); }}
                            />
                        </div>

                        <Dialog
                            header="Upload hardware"
                            visible={uploadDialogVisible}
                            onHide={() => { setUploadDialogVisible(false); setHardwareFile(null); setImeiList([]); setImeiParseError(null); }}
                            dismissableMask
                            style={{ width: "480px" }}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                <p style={{ margin: 0, color: "#6e6e6e", fontSize: "15px" }}>
                                    Select a file to upload hardware data.
                                </p>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={handleHardwareFileChange}
                                />
                                {hardwareFile && !imeiParseError && imeiList.length > 0 && (
                                    <p style={{ margin: 0, color: "#6e6e6e", fontSize: "13px" }}>
                                        <strong>{hardwareFile.name}</strong> — {imeiList.length} IMEI{imeiList.length !== 1 ? "s" : ""} found
                                    </p>
                                )}
                                {imeiParseError && (
                                    <p style={{ margin: 0, color: "#e24c4c", fontSize: "13px" }}>
                                        {imeiParseError}
                                    </p>
                                )}
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                    <Button
                                        label="Cancel"
                                        severity="secondary"
                                        outlined
                                        onClick={() => { setUploadDialogVisible(false); setHardwareFile(null); setImeiList([]); setImeiParseError(null); }}
                                    />
                                    <Button
                                        label="Upload"
                                        icon="pi pi-check"
                                        severity="success"
                                        disabled={imeiList.length === 0}
                                        onClick={() => {
                                            console.log("IMEIs to upload:", imeiList);
                                            setUploadDialogVisible(false);
                                            setLoadingDialogVisible(true);
                                            UploadHardware()
                                        }}
                                    />
                                </div>
                            </div>
                        </Dialog>

                        <Dialog
                            header="Uploading hardware..."
                            visible={loadingDialogVisible}
                            onHide={() => { setLoadingDialogVisible(false); window.location.reload(); }}
                            style={{ width: "30vw" }}
                            closable={false}
                        >
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                <Lottie animationData={loadingAnim} loop style={{ width: 250, height: 250 }} />
                                <Button
                                    label="Close"
                                    severity="danger"
                                    onClick={() => { setLoadingDialogVisible(false); window.location.reload(); }}
                                />
                            </div>
                        </Dialog>
                    </>
                )}

                <br></br>

                <div className={classes.tabsWrapper}>
                    <div className={classes.tabs}>
                        {["Gateways", "Analytics"].map((tab, i) => (
                            <button
                                key={tab}
                                className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                                onClick={() => setActiveTab(i)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    <div className={classes.tabContent}>
                        {activeTab === 0 && (
                            isLoading ? (
                                <div style={{ display: "flex", width: "100%" }}>
                                    <DeviceLoadingGrid CardCount={20} />
                                </div>
                            ) : (
                                <PadlocksList
                                    locks={gateways}
                                    filtering={filtering}
                                    update={update}
                                    setUpdate={setUpdate}
                                    isGateways={true}
                                />
                            )
                        )}

                        {activeTab === 1 && (
                            <div style={{ width: "100%" }}>
                                <RTSectionHeaderGateway 
                                    title="Gateways Health - Last 14 Days" 
                                    onRefresh={handleRefreshStats} 
                                    bsToggle={bsToggle} setBSToggle={setBSToggle} 
                                    powerSource={powerSource} setPowerSource={setPowerSource} 
                                    gwSearchTerm={gwSearchTerm} setGwSearchterm={setGwSearchterm}
                                    generatePDF={generatePDF}
                                    data={heatmapData}
                                    />
                                <br />
                    
                                {isLoadingScheduleStats ? (
                                    <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                                        <div style={{ flex: "1 1 0%", minWidth: 0 }}><SkeletonBarChart /></div>
                                        {!bsToggle && <div style={{ flex: "1 1 0%", minWidth: 0 }}><SkeletonBarChart /></div>}
                                    </div>
                                ) : (
                                    <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                                        {(bsToggle === null || bsToggle === "Battery") && (
                                            <div style={{ flex: "1 1 0%", minWidth: 0 }}>
                                                <HeatmapCard
                                                    data={heatmapData.battery}
                                                    type="Battery"
                                                    labels={heatmapData.labels}
                                                    onCellClick={handleCellClick}
                                                    chartRef={batteryChartRef}
                                                />
                                            </div>
                                        )}
                                        {(bsToggle === null || bsToggle === "Signal") && (
                                            <div style={{ flex: "1 1 0%", minWidth: 0 }}>
                                                <HeatmapCard
                                                    data={heatmapData.signal}
                                                    type="Signal"
                                                    labels={heatmapData.labels}
                                                    onCellClick={handleCellClick}
                                                    chartRef={signalChartRef}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Await>
    );
};

export default Gateways;
